<script setup lang="ts" generic="T extends RowData">
import type { RowData } from "@tanstack/vue-table";
import { computed } from "vue";
import type { FacetedOptions } from "./composables/faceted-types";
import { useFilterableColumns } from "./composables/filterable-columns";
import DataCollectionActiveFilter from "./DataCollectionActiveFilter.vue";

const props = defineProps<{
	options: FacetedOptions<T>;
	compact?: boolean;
	maxCount?: number;
}>();

const { sortedFilterableColumns } = useFilterableColumns(() => props.options);
const hasLiveFilters = computed<boolean>(() => {
	for (const col of sortedFilterableColumns.value) {
		if (col.getIsFiltered()) return true;
	}
	return false;
});
</script>

<template>
	<div v-if="hasLiveFilters" class="flex flex-wrap gap-2">
		<template v-for="col of sortedFilterableColumns" :key="col.id">
			<DataCollectionActiveFilter
				v-if="col.getIsFiltered()"
				:column="col"
				:options="options[col.id]"
				:compact="compact"
				:maxCount="maxCount"
			/>
		</template>
	</div>
</template>
